module.exports = __webpack_public_path__ + "e527941225f95563ea4f1a8ffcc3f77f.svg";